import type { ICarrier, IMyUsers, IOffer, IShipperContact, IFacilityReview, IPhoto } from 'src/types/types';
import httpCommon from './http-common';
import type { AxiosResponse } from 'axios';

export default class CustomerCompanyService {
    public static async getCustomerCompanyById(
        id: string,
        fields: string = 'all'
    ): Promise<AxiosResponse<{ customer_company: Partial<App.CustomerCompany>, consuming: { time: string, memory: string }, business: { stripe_customer_portal_url: string } }>> {
        return await httpCommon.get(`/customer_companies/${id}?fields=${fields}`);
    }

    public static async getCustomerCompanyUsersById(
        id: string,
        limit: any,
        offset: any
    ): Promise<AxiosResponse<{ customer_company_users: IMyUsers[], paging: { total_pages: number, page_size: number, matching_items: string, current_page: number } }>> {
        return await httpCommon.get(`/customer_companies/${id}/users?limit=${limit}&offset=${offset}`);
    }

    public static async getD411IDsByCustomerCompanyId(id: string, limit: any, offset: any) {
        return await httpCommon.get(`/customer_companies/${id}/d411_ids?limit=${limit}&offset=${offset}`);
    }

    public static putCustomerCompanyByKey(id: string | number, data: any) {
        return httpCommon.put<App.CustomerCompany>(`/customer_companies/${id}`, data).then((res) => {
            return res.data;
        });
    }

    public static getCustomerCompanyD411IdQuestions(limit: any, offset: any) {
        return httpCommon.get<App.CustomerCompany>(`/customer_companies/id/d411_id_questions?fields=all&limit=${limit}&offset=${offset}&sort=insert_sequence,DESC`).then((res) => {
            return res.data;
        });
    }

    public static getCustomerCompanyByKey(id: string | number) {
        return httpCommon.get<{ customer_company: App.CustomerCompany }>(`/customer_companies/${id}?fields=all`).then(res => {
            return res.data;
        });
    }

    public static async getOffer(customerCompanyId: string) {
        return await httpCommon.get<{ offer: IOffer }>(`/customer_companies/${customerCompanyId}/offers`);
    }
    public static async acceptTermsAndConditions(companyId: string) {
        return httpCommon.put(`/customer_companies/${companyId}/accepted_ts_and_cs`, {}).then((res) => {
            return res.data;
        });
    }
    public static postImage({ file, cid }: { file: File, cid: string }) {
        const formData = new FormData();
        formData.append('entity_type_code', 'company_logo');
        formData.append('entity_id', cid);
        formData.append('photo', file);

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        return httpCommon.post(`/customer_companies/${cid}/logos`, formData, config);
    }

    public static async getCarriers(limit: number, offset: number) {
        return httpCommon.get(`/shipper_carriers_with_contacts?limit=${limit}&offset=${offset}`)
    }

    public static async postCarriers(file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        return httpCommon.post(`/shipper_carriers_upload_requests`, formData, config)
    }

    public static async postCarrier(carrier: Partial<ICarrier>) {
        return httpCommon.post(`/shipper_carriers`, carrier)
    }

    public static async postCarrierContact(shipperContact: Partial<IShipperContact>) {
        return httpCommon.post(`/shipper_carriers_contacts`, shipperContact)
    }


    public static async deleteCarrierContact(shipperContactId: string) {
        return httpCommon.delete(`/shipper_carriers_contacts/${shipperContactId}`)
    }

    public static async deleteCarrier(carrierId: string) {
        return httpCommon.delete(`/shipper_carriers/${carrierId}`)
    }
    public static async getReports(period: string) {
        return httpCommon.get(`reports/profiles_views_and_reviews_report?format=xls&report_period=${period}`, {
            responseType: 'blob'
        });
    }
    public static async getReviewsForMyFacilities(limit: any, offset: any) {
        return await httpCommon.get<{ facility_reviews_for_my_facilities: IFacilityReview[], paging: { total_pages: number, page_size: number, matching_items: string, current_page: number } }>(`/facility_reviews_for_my_facilities?limit=${limit}&offset=${offset}`);
    }
    public static async getReview(reviewId: string) {
        return await httpCommon.get<{ facility_review: App.DockReview, media: { photos: IPhoto[], files: string[], videos: string[] } }>(`/facility_reviews/${reviewId}`);
    }
    public static async hideReview(reviewId: string) {
        return await httpCommon.post(`/facility_reviews/${reviewId}/hide_requests`);
    }

    public static async revealReview(reviewId: string) {
        return await httpCommon.post(`/facility_reviews/${reviewId}/reveal_requests`);
    }
    public static async answerReview(reviewId: string, company_response: string, status_code: 'approved' | 'rejected' | 'hidden' | 'reviewing' | 'internal') {
        return await httpCommon.put(`/facility_reviews/${reviewId}`, {
            company_response,
            status_code
        });
    }
}


export const getCustomerCompanyById = async (companyId: string) =>
    await httpCommon.get<AxiosResponse>(`/customer_companies/${companyId}?fields=all`);

